export const environment = {
  production: false,
  baseUrl: 'https://med-learn-pro-dev.azurewebsites.net',
};
